import { goRequest } from '../utils/httpClientTs';
import { GroupType, GroupRole } from '../types/group';

/**
 * Get group types by scope
 * @param scope - 'international' | 'spd_chapter' | 'local_chapter'
 * @returns Promise<GroupType[]>
 */
export const getGroupTypes = async (scope: string): Promise<GroupType[]> => {
  return goRequest({
    url: '/api/groups/types',
    method: 'GET',
    params: { scope },
  });
};

/**
 * Get group roles by group type ID
 * @param groupTypeId - The ID of the group type
 * @returns Promise<GroupRole[]>
 */
export const getGroupRolesByType = async (
  groupTypeId: string
): Promise<GroupRole[]> => {
  return goRequest({
    url: `/api/groups/types/${groupTypeId}/roles`,
    method: 'GET',
  });
};
